import type {
  validationRuleDetailResource,
  validationRuleResource,
} from '@porotutu/api/features/crm/validation_rules/resource'
import { exportHrefFor, unwrap } from '@porotutu/react/api'
import type { ListMeta, ListQuery } from '@porotutu/react/paging'
import { keepPreviousData, queryOptions } from '@tanstack/react-query'
import { crm } from '@/api/client'
import { VALIDATION_RULES } from '@/api/keys'
import type { CrmValidationRuleSort } from '../vocabulary'

export type ValidationRule = ReturnType<typeof validationRuleResource>
export type ValidationRuleDetail = ReturnType<typeof validationRuleDetailResource>

export type ValidationRulePage = { data: ValidationRule[]; meta: ListMeta }

export type ValidationRuleListQuery = ListQuery<CrmValidationRuleSort, never>

export const validationRulesQuery = (query: ValidationRuleListQuery) =>
  queryOptions({
    queryKey: [...VALIDATION_RULES, 'list', query] as const,
    queryFn: async () => unwrap(await crm['validation-rules'].get({ query })),
    placeholderData: keepPreviousData,
    staleTime: 15_000,
  })

export const validationRuleQuery = (id: string) =>
  queryOptions({
    queryKey: [...VALIDATION_RULES, 'record', id] as const,
    queryFn: async () => unwrap(await crm['validation-rules']({ id }).get()),
    staleTime: 30_000,
  })

export const exportHref = exportHrefFor<ValidationRuleListQuery>(
  '/api/v1/crm/validation-rules/export',
  { always: [], viewed: ['search'] },
)
